import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerErrorComponent } from '../components/server-error/server-error.component';

export const httpErrorInterceptor: HttpInterceptorFn = (
	request: HttpRequest<unknown>,
	next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
	const snackBar = inject(MatSnackBar)

	return next(request).pipe(
		tap({
			error: (error: HttpErrorResponse) => {
				if (error.status === 500) {
					// Log server error response
					console.log('----response----')
					console.error('status code:', error.status)
					console.error(error.message)
					console.error(error.error)
					console.log('--- end of response---')

					setTimeout(() => {
						// Show server error component as snackbar
						snackBar.openFromComponent(ServerErrorComponent, {
							horizontalPosition: 'center',
							verticalPosition: 'top',
							panelClass: 'app-snack-bar',
						})
					}, 10)
				}
			}
		})
	)
}
